import React, { Component } from 'react'
import EventTracker from '../../helpers/EventTracker'
import lambdaAPI from '../../lambdaAPI'
import get from 'lodash/get'

export default class NewsletterWidget extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            isSubmitting: false,
            error: null,
            success: false,
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault()
        this.setState({ isSubmitting: true, error: null, success: false })

        try {
            // Track the signup attempt
            EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.SIGNUP, EventTracker.EVENT_TYPES.SUBMIT, 'NEWSLETTER_SIGNUP')

            // Call the newsletter subscription API
            const response = await lambdaAPI.subscribeNewsletter(this.state.email, { tags: this.props.data.tags })

            if (response.success) {
                // Track successful signup
                EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.SIGNUP, EventTracker.EVENT_TYPES.SUCCESS, 'NEWSLETTER_SIGNUP')

                this.setState({
                    isSubmitting: false,
                    success: true,
                    email: '',
                })
            } else {
                throw new Error(response.message || 'Subscription failed')
            }
        } catch (error) {
            // Track failed signup
            EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.SIGNUP, EventTracker.EVENT_TYPES.ERROR, 'NEWSLETTER_SIGNUP')

            let errorMessage = 'Something went wrong. Please try again.'

            // Handle already subscribed error (409 conflict)
            if (error.message && error.message.includes('already subscribed')) {
                errorMessage = 'This email is already subscribed to our newsletter.'
            }
            // Handle validation errors
            else if (error.message && error.message.includes('Invalid')) {
                errorMessage = error.message
            }
            // Handle other API error messages
            else if (error.message) {
                errorMessage = error.message
            }

            this.setState({
                isSubmitting: false,
                error: errorMessage,
            })
        }
    }

    handleEmailChange = (e) => {
        this.setState({ email: e.target.value })
    }

    render() {
        const { className, title, description, image, successMessage } = this.props.data
        const { email, isSubmitting, error, success } = this.state
        const descriptionText = get(description, 'description', '')

        return (
            <div className={`newsletter-form ${className || ''}`}>
                <div className="newsletter-content">
                    <div className="newsletter-image" style={{ backgroundImage: `url(${image?.file?.url})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                    <form onSubmit={this.handleSubmit} className="newsletter-form-container">
                        <div className="newsletter-text">
                            <h2>{title || 'Join the Starship Whānau'}</h2>
                            <p>{descriptionText || 'Sign up to receive uplifting stories, expert tips on child health, and the latest updates from Starship, all in one heartfelt newsletter.'}</p>
                        </div>

                        <div className="input-group">
                            <input type="email" value={email} onChange={this.handleEmailChange} placeholder="Enter your email address" required aria-label="Email address" className={error ? 'error' : ''} />
                            <button type="submit" disabled={isSubmitting} className="subscribe-button">
                                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                            </button>
                        </div>
                        {error && <div className="error-message">{error}</div>}
                        {success && <div className="success-message">{successMessage?.successMessage || 'Thank you for subscribing! Please check your email to confirm your subscription.'}</div>}
                    </form>
                </div>
            </div>


        )
    }
}
